import en from "./en/en"
import jp from "./jp/jp"

export default {
    jp,
    en
}
